/**
 * @generated SignedSource<<61199098d2edbe322e57b3bc9f436706>>
 * @relayHash 84089950a098de741b9cc8fe7be37f4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af1dedc24d118e6831ee24c6433181b68321c163ef93c3578dd8d71d3a98b3be

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResultRequestFormQuery$variables = {
  cloudId: string;
  helpCenterAri?: string | null;
  portalIds?: ReadonlyArray<string> | null;
  queryTerm: string;
  resultLimit?: number | null;
};
export type searchResultRequestFormQuery$data = {
  readonly helpObjectStore: {
    readonly __typename: "HelpObjectStoreQueryApi";
    readonly " $fragmentSpreads": FragmentRefs<"requestFormsFragment">;
  };
};
export type searchResultRequestFormQuery = {
  response: searchResultRequestFormQuery$data;
  variables: searchResultRequestFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "portalIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryTerm"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resultLimit"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "searchResultRequestFormQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v6/*: any*/),
          "concreteType": "HelpObjectStoreQueryApi",
          "kind": "LinkedField",
          "name": "helpObjectStore",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "requestFormsFragment"
            }
          ]
        },
        "action": "THROW",
        "path": "helpObjectStore"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "searchResultRequestFormQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpObjectStoreQueryApi",
        "kind": "LinkedField",
        "name": "helpObjectStore",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": "requestForms",
            "args": [
              {
                "fields": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "entityType",
                    "value": "REQUEST_FORM"
                  },
                  {
                    "kind": "Variable",
                    "name": "helpCenterAri",
                    "variableName": "helpCenterAri"
                  },
                  {
                    "kind": "Variable",
                    "name": "portalIds",
                    "variableName": "portalIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "queryTerm",
                    "variableName": "queryTerm"
                  },
                  {
                    "kind": "Variable",
                    "name": "resultLimit",
                    "variableName": "resultLimit"
                  }
                ],
                "kind": "ObjectValue",
                "name": "searchInput"
              }
            ],
            "kind": "LinkedField",
            "name": "searchHelpObjects",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isExternal"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "searchBackend"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "title"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayLink"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "searchAlgorithm"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "entityType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                  }
                ],
                "type": "HelpObjectStoreSearchResult"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "HelpObjectStoreQueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "af1dedc24d118e6831ee24c6433181b68321c163ef93c3578dd8d71d3a98b3be",
    "metadata": {},
    "name": "searchResultRequestFormQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "767d90ed3aed24eab0f0598281dd235e";

export default node;
